import React from 'react'
import { ExpandMore, ExpandLess } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  icon: {
    color: theme.palette.secondary.main,
    fontSize: '2rem',
  },
}))

interface ExpandCollapseIconProps {
  onClickHandler?: () => void
  showGroup: boolean
  className?: string
  size?: 'small' | 'medium'
  id?: string
}

const ExpandCollapseIcon: React.FC<ExpandCollapseIconProps> = ({
  onClickHandler,
  showGroup,
  className,
  size = 'small',
  id,
}) => {
  const { classes } = useStyles()
  const ExpandCollapseIcon = showGroup ? ExpandLess : ExpandMore
  return (
    <IconButton
      id={id}
      onClick={onClickHandler}
      size={size}
      aria-label={showGroup ? 'Hide Group' : 'Show Group'}
    >
      <ExpandCollapseIcon className={className || classes.icon} />
    </IconButton>
  )
}

export default ExpandCollapseIcon
